import React from 'react';

export default function PremiumToggle({ value, onChange }) {
  return (
    <div
      className="flex items-center justify-between rounded-xl px-4 py-3"
      style={{ backgroundColor: '#0f1117', border: '1px solid #1e2130' }}
    >
      <div>
        <p className="text-sm font-medium text-gray-300">Premium Query</p>
        <p className="text-xs mt-0.5" style={{ color: '#4b5563' }}>Requires premium license to run</p>
      </div>
      <button
        type="button"
        onClick={onChange}
        className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none"
        style={{ backgroundColor: value ? '#3b82f6' : '#1e2130' }}
      >
        <span
          className="inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform duration-200"
          style={{ transform: value ? 'translateX(22px)' : 'translateX(4px)' }}
        />
      </button>
    </div>
  );
}
